const get = (key) => {
  const value = localStorage.getItem(key);

  if (value === null) {
    return value;
  }

  return JSON.parse(value);
};

const set = (key, value) => localStorage.setItem(key, JSON.stringify(value));

const clear = (key) => localStorage.removeItem(key);

export default { get, set, clear };
